/* KAECE Concierge · Step 2C · 26.10.26 · answers aligned to the brand terms 29.10.26, made to measure added (on request)
   A drawer from the right, in Search's place, so the garment stays in view. He types: garments appear at once (Shopify's own search, no app).
   He asks: the answer comes from KAECE's own published information (the Concierge page), or a person takes it.
   When window.KAECE_CONCIERGE.endpoint is set, questions go to the KAECE Worker (Claude) instead. No keys in the browser. */
(function () {
  'use strict';
  var cfg = window.KAECE_CONCIERGE || {};
  var MONEY = window.KAECE_MONEY || '£{{amount}} GBP';
  var EMAIL = 'team@kaece.co';
  var STORE = 'kaece-concierge-v2';

  /* Answers, word for word from kaece.co/pages/concierge. Change them there and here together. */
  var A = {
    delivery: 'Delivery is complimentary and tracked, worldwide, and KAECE covers duties and import taxes, so there is nothing to pay on delivery. Orders are prepared within 1-3 working days. In the UK, they travel by Royal Mail and arrive within 3-5 days of dispatch. To the EU, US and Canada, allow 7-10 working days. Elsewhere, times vary by destination and your tracking confirms the date.',
    returns: 'Returns and exchanges are complimentary. You have 30 days from delivery to return or exchange any garment, unworn and unwashed. Email team@kaece.co with your order number. We will arrange the return for you at no cost.',
    size: 'Every KAECE garment has an athletic cut. Size up for a more relaxed profile.\n\nBetween sizes, choose the smaller size for a closer fit or the larger size for more room. Each garment\'s measurements are on its page, under Fit.',
    made: 'Italian fabric, Portuguese craftsmanship. Every KAECE garment is made in Portugal from Italian fabric, and the sock from Portuguese yarn. Designed in Kensington & Chelsea, under the creative direction of Ffion Appleton.',
    care: 'Wash inside out at max 40°C on a mild cycle, and the sock at max 30°C. Do not bleach, tumble dry or dry clean.',
    allocation: 'Some are. The pant and the half-zip are made in limited allocations: ordering one secures it from the next allocation, with confirmation and tracking before dispatch. Competition Spec is held by introduction.',
    measure: 'On request. Made to measure is arranged with the team, with a minimum of three pieces per garment. Write to team@kaece.co, or book a private fitting in Chelsea.',
    order: 'Email team@kaece.co with your order number as soon as possible. Before dispatch, we will do our best to change or cancel it.',
    pay: 'All major credit/debit cards and authorised payment providers.',
    fitting: 'A private fitting in Chelsea, with the team. Send a day and time that suit you and we will confirm.'
  };
  var RULES = [
    ['measure', /measure|tailor|bespoke|custom|commission/],
    ['fitting', /fitting|appointment|try on|chelsea|kx\b/],
    ['size', /size|fit\b|fits|sizing|tall|height|weigh|\bkg\b|\bcm\b|small|large|medium/],
    ['returns', /return|exchange|refund/],
    ['delivery', /deliver|ship|duty|duties|tax|arrive|track/],
    ['made', /made|make|fabric|material|portugal|italy|italian|where.*from/],
    ['care', /wash|care|clean|dry/],
    ['allocation', /allocation|limited|restock|sold out|competition spec|introduc/],
    ['order', /cancel|change.*order|order.*change/],
    ['pay', /pay|card|klarna|account/]
  ];
  var CHIPS = [['What size am I?', 'size'], ['Delivery and returns', 'delivery+returns'], ['Where is it made?', 'made'], ['Book a fitting in Chelsea', 'fitting']];

  function store(v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(STORE) || '[]'); sessionStorage.setItem(STORE, JSON.stringify(v.slice(-20))); } catch (e) { return []; } }
  var thread = store() || [];
  var productMatch = location.pathname.match(/\/products\/([^\/?#]+)/);
  var productHandle = productMatch ? decodeURIComponent(productMatch[1]) : '';

  var root, wash, scroll, top, dock, field, input, results, rlist, start, list, lastFocus, timer, ctrl, busy = false, isOpen = false;

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rich(s) {
    return esc(s).replace(/team@kaece\.co/g, '<a href="mailto:team@kaece.co">team@kaece.co</a>').replace(/\n/g, '<br>');
  }
  function money(amount) { return MONEY.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); }
  function short(t) { var n = String(t).replace(/^ATG (TRAINING|RUNNING) /i, ''); return /^system$/i.test(n) ? 'The System' : n; }

  function build() {
    if (root) return;
    wash = el('div', 'kc-wash');
    wash.addEventListener('click', close);
    root = el('div', 'kc');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'KAECE Concierge');
    root.innerHTML =
      '<div class="kc__head"><span class="kc__label">KAECE Concierge</span><button type="button" class="kc__close" data-kc-close>Close</button></div>' +
      '<div class="kc__scroll">' +
        '<div class="kc__top"></div>' +
        '<div class="kc__results" hidden><p class="kc__lab">Garments</p><ul class="kc__rows" role="list"></ul></div>' +
        '<div class="kc__start"><p class="kc__lab">Or ask</p><div class="kc__chips"></div></div>' +
        '<div class="kc__thread" aria-live="polite"></div>' +
      '</div>' +
      '<div class="kc__dock"></div>' +
      '<div class="kc__foot"><a href="mailto:' + EMAIL + '">Speak to a person · ' + EMAIL + '</a><button type="button" class="kc__link" data-kc-chip="fitting">Book a fitting</button></div>';
    field = el('form', 'kc__field');
    field.setAttribute('novalidate', '');
    field.innerHTML = '<label class="visually-hidden" for="kc-q">Ask anything, or find a garment</label>' +
      '<input id="kc-q" class="kc__input" type="text" autocomplete="off" maxlength="300" placeholder="Ask anything, or find a garment">' +
      '<button type="submit" class="kc__ask">Ask</button>';
    document.body.appendChild(wash);
    document.body.appendChild(root);
    scroll = root.querySelector('.kc__scroll');
    top = root.querySelector('.kc__top');
    dock = root.querySelector('.kc__dock');
    results = root.querySelector('.kc__results');
    rlist = root.querySelector('.kc__rows');
    start = root.querySelector('.kc__start');
    list = root.querySelector('.kc__thread');
    input = field.querySelector('input');
    top.appendChild(field);
    var chips = root.querySelector('.kc__chips');
    CHIPS.forEach(function (c) {
      var b = el('button', 'kc__chip', c[0]); b.type = 'button'; b.setAttribute('data-kc-chip', c[1]); b.setAttribute('data-kc-q', c[0]);
      chips.appendChild(b);
    });
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-kc-chip]');
      if (c) { e.preventDefault(); ask(c.getAttribute('data-kc-q') || c.textContent, c.getAttribute('data-kc-chip')); }
    });
    root.querySelector('[data-kc-close]').addEventListener('click', close);
    field.addEventListener('submit', function (e) { e.preventDefault(); var q = input.value.trim(); if (q) ask(q); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 140); });
    root.addEventListener('keydown', trap);
    if (thread.length) { chat(true); thread.forEach(function (m) { say(m.r, m.t); }); }
  }

  function chat(on) {
    root.classList.toggle('is-chat', on);
    /* In a conversation the field sits at the foot, so garments found while typing sit just above it, under the last answer */
    if (on) { dock.appendChild(field); start.hidden = true; scroll.appendChild(results); }
    else { top.appendChild(field); start.hidden = false; top.after(results); }
  }

  function search() {
    var q = input.value.trim();
    if (ctrl) ctrl.abort();
    if (q.length < 2) { results.hidden = true; rlist.innerHTML = ''; return; }
    ctrl = window.AbortController ? new AbortController() : null;
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
      var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
      /* Shopify's search is semantic and returns every garment; when some titles match what he typed, show only those */
      var words = q.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 1; });
      var hits = ps.filter(function (p) {
        var t = short(p.title).toLowerCase().split(/[^a-z0-9]+/);
        return words.length && words.every(function (w) { return t.some(function (x) { return x.indexOf(w) === 0; }); });
      });
      ps = (hits.length ? hits : ps).slice(0, 3);
      rlist.innerHTML = '';
      ps.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        var li = el('li', 'kc__row');
        li.innerHTML = '<a href="' + esc(p.url) + '"><span class="kc__th">' + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48">' : '') + '</span>' +
          '<span class="kc__nm"><span>' + esc(short(p.title)) + '</span><span class="kc__pr">' + esc(money(p.price)) + '</span></span><span class="kc__go">View</span></a>';
        rlist.appendChild(li);
      });
      results.hidden = !ps.length;
      if (root.classList.contains('is-chat')) scroll.scrollTop = scroll.scrollHeight;
    }).catch(function () {});
  }

  function say(role, text) {
    var m = el('div', 'kc__msg kc__msg--' + (role === 'u' ? 'you' : 'kc'));
    m.appendChild(el('p', 'kc__who', role === 'u' ? 'You' : 'Concierge'));
    var t = el('div', 'kc__text');
    if (text != null) t.innerHTML = rich(text);
    m.appendChild(t);
    list.appendChild(m);
    scroll.scrollTop = scroll.scrollHeight;
    return t;
  }

  function match(q) {
    q = q.toLowerCase();
    for (var i = 0; i < RULES.length; i++) if (RULES[i][1].test(q)) return RULES[i][0];
    return '';
  }

  function answerFor(q, key) {
    key = key || match(q);
    if (key === 'delivery+returns') return A.delivery + '\n\n' + A.returns;
    if (key === 'size') return A.size + '\n\nOr book a private fitting in Chelsea.';
    if (key && A[key]) return A[key];
    return '';
  }

  function ask(q, key) {
    if (busy) return;
    q = String(q || '').trim();
    if (!q) return;
    input.value = ''; results.hidden = true; rlist.innerHTML = '';
    chat(true);
    thread.push({ r: 'u', t: q }); store(thread);
    say('u', q);
    var out = say('k', null);
    if (cfg.endpoint && !key) { live(q, out); return; }
    var a = answerFor(q, key);
    var actions = '';
    if (key === 'fitting' || /fitting/i.test(q)) actions = '<a class="kc__act" href="mailto:' + EMAIL + '?subject=' + encodeURIComponent('Private fitting in Chelsea') + '">Email to book</a>';
    if (!a) {
      a = 'A person will answer this one. Send it to team@kaece.co and the team will reply.';
      actions = '<a class="kc__act" href="mailto:' + EMAIL + '?subject=' + encodeURIComponent('KAECE Concierge') + '&body=' + encodeURIComponent(q) + '">Send to the team</a>';
    }
    out.innerHTML = rich(a) + (actions ? '<div class="kc__acts">' + actions + '</div>' : '');
    out.parentNode.classList.add('is-in');
    thread.push({ r: 'k', t: a }); store(thread);
    scroll.scrollTop = scroll.scrollHeight;
  }

  function live(q, out) {
    busy = true;
    var acc = '';
    var cursor = el('span', 'kc__cursor'); out.appendChild(cursor);
    var msgs = thread.map(function (m) { return { role: m.r === 'u' ? 'user' : 'assistant', content: m.t }; });
    fetch(cfg.endpoint.replace(/\/$/, '') + '/chat', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: msgs.slice(-20), context: { page: location.pathname, product: productHandle } })
    }).then(function (res) {
      if (!res.ok || !res.body) throw new Error('status ' + res.status);
      var reader = res.body.getReader(), dec = new TextDecoder();
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) return;
          acc += dec.decode(r.value, { stream: true });
          out.textContent = acc; out.appendChild(cursor); scroll.scrollTop = scroll.scrollHeight;
          return pump();
        });
      }
      return pump();
    }).catch(function () {
      acc = answerFor(q) || 'The concierge is unavailable for a moment. The team will help on team@kaece.co.';
    }).then(function () {
      out.innerHTML = rich(acc.trim());
      thread.push({ r: 'k', t: acc.trim() }); store(thread);
      busy = false;
    });
  }

  function trap(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(root.querySelectorAll('button, [href], input'), function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(prompt) {
    build();
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    var drawer = document.querySelector('[data-drawer-menu].active [data-close-drawer]');
    if (drawer) drawer.click();
    wash.classList.add('is-open');
    root.classList.add('is-open');
    document.documentElement.classList.add('kc-lock');
    setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    if (prompt) ask(prompt);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    wash.classList.remove('is-open');
    root.classList.remove('is-open');
    document.documentElement.classList.remove('kc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kc-open]');
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-kc-prompt') || '');
  });
  if (location.hash === '#concierge') open();
  window.KAECE = window.KAECE || {};
  window.KAECE.concierge = { open: open, close: close };
})();
